import "./Services.module.css";
import SiteHeader from "@/reusable_sections/Header";
import AllServices from "./sections/AllServices";
import ProjectPath from "./sections/ProjectPath";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <SiteHeader />
      <AllServices />
      <ProjectPath />
      <Footer />
    </div>;
}